import { Link } from "react-router-dom";
import mapLink from "assets/map-link.png";
import { RoutePathsEnum } from "infrastructure/RoutePathsEnum";
import { SourceEnum } from "modules/sourceEnum";

const MapViewTemplate = (props: any): any => {
  const { latitude, longitude, id } = props;
  const linkToMaps = `${RoutePathsEnum.Map}/${SourceEnum.WorkOrders}/${SourceEnum.DisposalSite}/${id}`;

  return (
    <div className="d-flex justify-content-center align-items-center col-map-view overflow-auto">
      {latitude && longitude && (
        <>
          <img src={mapLink} alt="Pin Icon" />
          <Link
            to={linkToMaps}
            data-testid="view-map"
          >
            View
          </Link>
        </>
      )}
      {!(latitude && longitude) && (
        <span className="map-link-error">Error</span>
      )}
    </div>
  );
};
export default MapViewTemplate;
